import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@/ui';
import { Spin, Typography } from 'antd';
import { ItemSection } from '@/pages/admin/Statics/ItemSection';
import { useGetStaticsAdmin } from '@/features/statics/hooks/useGetStatics';
import { useUpdateStatics } from '@/features/statics/hooks/useUpdateStatics';
import styled from 'styled-components';

export const Statics = () => {
  const { t } = useTranslation();
  const { data, isLoading, error } = useGetStaticsAdmin();
  const { handleUpdate, isUpdating } = useUpdateStatics();

  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative'
        }}
      >
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <Container $paddingY={20}>
        <Typography.Text>Error loading statics schema</Typography.Text>
      </Container>
    );
  }

  if (data)
    return (
      <Container $paddingY={20}>
        <Container $marginBottom={30}>
          <Typography.Title level={3}>{t('Statics')}</Typography.Title>
        </Container>
        {data.map((item) => (
          <ItemSection
            data={item}
            key={item.id}
            isUpdating={isUpdating}
            handleUpdate={handleUpdate}
          />
        ))}
      </Container>
    );
};

export const Loading = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 20px;
  width: 20px;
`;
